import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Row, Col, Form, Button } from '_zari/core'

import * as CompaniaService from 'services/compania.service'

import * as FormGroups from './formGroups'

const AdministrativoSection = ({ edicionData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      validacionDocumentosPendientes: edicionData.validacionDocumentosPendientes ?? false,
      flagRecalculoCostos: edicionData.flagRecalculoCostos ?? false,
      flagDobleImpresora: edicionData.flagDobleImpresora ?? false,
      flagUsoPresupuesto: edicionData.flagUsoPresupuesto ?? false
    }
  }, [edicionData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      CompaniaService.insertarActualizarCompaniaConfiguracion(data)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado la informacion.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ errors, touched, values, isSubmitting, handleSubmit }) => (
        <Form>
          <Row>
            <Col md={4}>
              <FormGroups.ValidacionDocumentosPendientesFormGroup
                iValue={values.validacionDocumentosPendientes}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={4}>
              <FormGroups.FlagRecalculoCostosFormGroup
                iValue={values.flagRecalculoCostos}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={4}>
              <FormGroups.FlagDobleImpresoraFormGroup iValue={values.flagDobleImpresora} fIsSubmitting={isSubmitting} />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroups.FlagUsoPresupuestoFormGroup iValue={values.flagUsoPresupuesto} fIsSubmitting={isSubmitting} />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col md={12} className='text-right'>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Procesar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(AdministrativoSection)
